import ReactMarkdown from "react-markdown";

/**
 * Passport-branded markdown renderer for AI-composed itineraries and dates.
 * Restrained styling — bold uses gold accent, headings use serif, lists are
 * tight, links open safely. No plugins, no HTML injection.
 */
export default function AIMarkdown({ children, className = "" }) {
    return (
        <div className={`ai-md text-white/85 leading-relaxed ${className}`}>
            <ReactMarkdown
                components={{
                    h1: ({ node, ...props }) => (
                        <h1 className="font-serif text-2xl md:text-3xl text-white mt-6 mb-3 tracking-tight" {...props} />
                    ),
                    h2: ({ node, ...props }) => (
                        <h2 className="font-serif text-xl text-white mt-5 mb-2 tracking-tight" {...props} />
                    ),
                    h3: ({ node, ...props }) => (
                        <h3 className="text-sm uppercase tracking-[0.2em] mt-5 mb-2" style={{ color: "var(--gold)" }} {...props} />
                    ),
                    p: ({ node, ...props }) => (
                        <p className="my-3 text-white/85" {...props} />
                    ),
                    strong: ({ node, ...props }) => (
                        <strong className="font-semibold" style={{ color: "var(--gold-pale, #E4C46D)" }} {...props} />
                    ),
                    em: ({ node, ...props }) => (
                        <em className="italic text-white/75" {...props} />
                    ),
                    ol: ({ node, ...props }) => (
                        <ol className="list-decimal pl-6 my-3 space-y-2 marker:text-[color:var(--gold)]" {...props} />
                    ),
                    ul: ({ node, ...props }) => (
                        <ul className="list-disc pl-6 my-3 space-y-2 marker:text-[color:var(--gold)]" {...props} />
                    ),
                    li: ({ node, ...props }) => (
                        <li className="text-white/85" {...props} />
                    ),
                    hr: () => (
                        <div className="my-6 h-px" style={{ background: "linear-gradient(90deg, transparent, rgba(212,175,55,0.35), transparent)" }} />
                    ),
                    a: ({ node, ...props }) => (
                        <a
                            target="_blank"
                            rel="noopener noreferrer"
                            className="underline underline-offset-4"
                            style={{ color: "var(--gold)" }}
                            {...props}
                        />
                    ),
                    blockquote: ({ node, ...props }) => (
                        <blockquote className="border-l-2 pl-4 my-3 italic text-white/70" style={{ borderColor: "var(--gold)" }} {...props} />
                    ),
                    code: ({ inline, node, ...props }) =>
                        inline ? (
                            <code className="px-1 py-0.5 rounded text-xs" style={{ background: "rgba(255,255,255,0.06)", color: "var(--gold)" }} {...props} />
                        ) : (
                            <pre className="p-3 rounded-lg overflow-x-auto text-xs" style={{ background: "rgba(0,0,0,0.35)" }}>
                                <code {...props} />
                            </pre>
                        ),
                }}
            >
                {children || ""}
            </ReactMarkdown>
        </div>
    );
}
